import { cn } from '../../lib/cn';
import styles from './Spinner.module.css';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export function Spinner({ label, spinnerSize = 'md', dataTestId }: { label?: string; spinnerSize?: SpinnerSize; dataTestId?: string }) {
  return (
    <div
      data-testid={dataTestId}
      className={styles.wrap}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-busy="true"
    >
      <div className={cn(styles.ring, styles[`size_${spinnerSize}`])} />
      {label ? <p className={styles.label}>{label}</p> : null}
    </div>
  );
}
